// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__FiJjR","content":"styles_content__12eG6","selectAll":"styles_selectAll__3JTYl"};